import styled from 'styled-components';
import tw from 'tailwind.macro';

export interface StyledProps {
  section?: boolean;
}

export const Container = styled.div<StyledProps>`
  ${tw`flex flex-wrap max-w-screen-md w-full mx-auto p-5`};
  ${({ section }) => section && tw`py-8 sm:py-16`};

  code, pre {
    ${tw`max-w-screen-md w-full my-4`};
  }

  pre code {
    border-left: 2px black solid;
    display: inline-block;
    overflow: auto;
    padding-left: 1rem;
  }

  blockquote {
    ${tw`font-serif text-3xl italic border-l-8 mx-0 p-5 my-3`};

    &:before {
      content: open-quote;
      ${tw`font-serif text-5xl text-gray-300 italic mr-1`};
      vertical-align: 0em;
    }

    p {
      display: inline;
    }
  }
`;
